import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "../AxiosClient";

export const uploadAsync = createAsyncThunk(
  "admin/upload",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/upload/file`, payload, toolkit);
  }
);
